import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { fetchSessions } from "../../../../actions/mine_craft/sessionsActions";
import { queryParams } from "../../../../helpers/UrlHelpers";

import Pagination from "../../../../componets/Pagination";
import Card from "../../../../componets/Card";
import SessionsList from "../../Sessions/_partials/_ListTable";

const LIMIT = 20;

const _Sessions = ({ userId }: { userId: number | undefined }) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const count           = useAppSelector(state => state.mineCraft.sessions.count);

  useEffect(() => {
    if (!userId) {
      return;
    }

    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT,
      user_id: userId
    };

    dispatch(fetchSessions(params))
  }, [userId, currentPage, dispatch]);

  return (
    <Card>
      <h4 className='v-content-title'>Sessions</h4>
      <SessionsList />

      <Pagination total={count} size={LIMIT} />
    </Card>
  )
}

export default _Sessions;
